(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
(() => {
  const mql = window.matchMedia('(min-width: 990px)');

  function openPanel(h, panel) {
    h.setAttribute('aria-expanded', 'true');
    h.classList.add('is-open');
    panel.classList.add('is-open');
    panel.style.display = 'block';   // forza inline: batte qualsiasi CSS residuo
  }
  function closePanel(h, panel) {
    h.setAttribute('aria-expanded', 'false');
    h.classList.remove('is-open');
    panel.classList.remove('is-open');
    panel.style.display = 'none';
  }
  function closeAll(container) {
    container.querySelectorAll('.footer-block__heading[role="button"][aria-controls]').forEach(h=>{
      const id=h.getAttribute('aria-controls'); const p=id && document.getElementById(id);
      if (p) closePanel(h,p);
    });
  }
  function sanitize(h, panel){
    h.classList.remove('block-collapsed','block-expanded');
    ['visibility','opacity','height','margin','padding','overflow','transition'].forEach(prop=>panel.style.removeProperty(prop));
  }

  function init(){
    const container = document.querySelector('.footer__blocks-wrapper');
    if (!container) return;

    // Stato iniziale coerente con viewport
    container.querySelectorAll('.footer-block__heading[role="button"][aria-controls]').forEach(h=>{
      const id=h.getAttribute('aria-controls'); const p=id && document.getElementById(id);
      if(!p) return;
      sanitize(h,p);
      if (mql.matches) openPanel(h,p); else closePanel(h,p);
    });

    // Delegation con capture: blocca gli handler di Dawn
    if (!container._bound){
      container.addEventListener('click', (e)=>{
        const h = e.target.closest('.footer-block__heading[role="button"][aria-controls]');
        if (!h) return;
        if (mql.matches) return; // desktop: nessun toggle
        e.preventDefault();
        e.stopPropagation();
        if (e.stopImmediatePropagation) e.stopImmediatePropagation();

        const id=h.getAttribute('aria-controls'); const p=id && document.getElementById(id);
        if(!p) return;

        const isOpen = h.getAttribute('aria-expanded') === 'true';
        closeAll(container);
        if (!isOpen) openPanel(h,p); // apri SUBITO quello cliccato
      }, true); // capture
      container._bound = true;
    }
  }

  document.addEventListener('DOMContentLoaded', init);
  window.addEventListener('load', init);
  mql.addEventListener('change', init);
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
class StickyHeader extends HTMLElement {
  constructor() {
    super();
    this.header = this;
    this.currentScrollTop = 0;
    this.preventReveal = false;
    this.predictiveSearch = this.querySelector('predictive-search');

    this.onScrollHandler = this.onScroll.bind(this);
    this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

    this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
    window.addEventListener('scroll', this.onScrollHandler, false);
  }

  onScroll() {
    const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

    if (scrollTop > this.currentScrollTop && scrollTop > 100) {
      this.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
    } else if (scrollTop < this.currentScrollTop) {
      this.classList.remove('shopify-section-header-hidden');
      this.classList.add('shopify-section-header-sticky');
    } else if (scrollTop <= 50) {
      this.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky');
    }

    this.currentScrollTop = scrollTop;
  }
}
customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
